import React from 'react';
import './../index.css';
import Section from './Section';

const Heading = ({ children }) => (
    <Section className="pb-0 mt-20 sm:mt-28">
      <h1 className='text-3xl font-medium tracking-tight uppercase text-midground md:text-5xl'>
        {children}
      </h1>
    </Section>
);

export default Heading;